module.exports = __webpack_public_path__ + "static/img/ios1.3.cf229422.jpg";